import type { B2bOverviewWorkspaceResponse } from '@np-forge/api-client/types'
import { type FC } from 'react'

import { SIDEBAR_TEST_IDS } from '@/constants/testIds'

import { WorkspaceDropdownItemBody } from './WorkspaceDropdownItemBody'

interface B2bWorkspaceDropdownProps {
  workspaces: B2bOverviewWorkspaceResponse[]
  currentWorkspaceId: string | undefined
  onSelect: (workspaceId: string) => void
}

/** The B2B workspaces from `GET /v1/b2b/me`, in the original dropdown's look. B2B workspaces are created by staff only. */
export const B2bWorkspaceDropdown: FC<B2bWorkspaceDropdownProps> = ({ workspaces, currentWorkspaceId, onSelect }) => (
  <div
    className="sidebar__org-dropdown"
    role="menu"
    aria-label="Workspace switcher"
    data-testid={SIDEBAR_TEST_IDS.ORGANIZATION_DROPDOWN}
  >
    <div className="sidebar__org-dropdown-header">
      <p>{workspaces.length === 0 ? 'No workspaces yet' : 'Your workspaces'}</p>
    </div>
    <div className="sidebar__org-dropdown-list">
      {workspaces.map(workspace => {
        const isCurrent = workspace.id === currentWorkspaceId
        return (
          <button
            key={workspace.id}
            type="button"
            className={`sidebar__org-dropdown-item ${isCurrent ? 'sidebar__org-dropdown-item--current' : ''}`}
            role="menuitem"
            aria-current={isCurrent ? 'true' : undefined}
            onClick={() => onSelect(workspace.id)}
          >
            <WorkspaceDropdownItemBody name={workspace.name} />
          </button>
        )
      })}
    </div>
  </div>
)
